/**
 * Formats a number with K suffix for thousands
 * @param num - The number to format
 * @returns Formatted string (e.g., "1.5K" for 1500)
 */
export const formatNumber = (num: number): string => {
  if (num >= 1000) {
    return `${(num / 1000).toFixed(1)}K`;
  }
  return num.toString();
};

/**
 * Formats a date with month, day, and year
 * @param date - The date to format
 * @returns Formatted date string (e.g., "January 1, 2024")
 */
export const formatDate = (date: Date) => {
  return date.toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  });
};

/**
 * Formats a wallet address with ellipsis
 * @param address - The wallet address to format
 * @returns Formatted wallet address string (e.g., "0x1234....5678")
 */
export const formatWalletAddress = (address: string) => {
  if (address.length <= 10) return address;
  return `${address.slice(0, 6)}....${address.slice(-4)}`;
};

/**
 * Calculates and formats the end time for a campaign
 * @param endDate - The campaign end date
 * @returns Formatted end time string (e.g., "5 days left", "Ends today", "Ended")
 */
export const calculateEndTime = (endDate: Date): string => {
  const now = new Date();
  const diffDays = Math.ceil(
    (endDate.getTime() - now.getTime()) / (1000 * 60 * 60 * 24),
  );

  if (diffDays < 0) return "Ended";
  if (diffDays === 0) return "Ends today";
  if (diffDays === 1) return "1 day left";
  return `${diffDays} days left`;
};
